var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopInfo, selectCoopMemberIsInProbation, selectCoopRole, } from "../../selectors/selectCoopInfo";
import { selectOngoingPlayerProfileInfo } from "../../selectors/selectOngoingPlayerProfileInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonListGreen } from "../generic/common/ButtonListGreen";
import { ButtonListNormal } from "../generic/common/ButtonListNormal";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { List } from "../generic/list/List";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopAssignMemberRole } from "./actionCoop";
import { IdCoopRole } from "./info-view/IdCoopRole";
import { mapCoopRole } from "./mapCoopRole";
var DialogCoopRoleManagementDOM = /** @class */ (function (_super) {
    __extends(DialogCoopRoleManagementDOM, _super);
    function DialogCoopRoleManagementDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedRole: _this.props.roleToAssign || IdCoopRole.Leader,
        };
        _this.Roles = [IdCoopRole.Leader, IdCoopRole.Deputy, IdCoopRole.Member];
        _this.getRoleLayout = function (role) {
            var roleObj = mapCoopRole.get(role);
            var selectedRole = _this.state.selectedRole;
            var currentPlayerRole = _this.props.currentPlayerRole;
            var isDisabled = currentPlayerRole !== IdCoopRole.Leader && role === IdCoopRole.Leader;
            var isSelected = selectedRole === role;
            var ButtonComponent = isSelected ? ButtonListGreen : ButtonListNormal;
            return (React.createElement("div", { className: "v-padding__medium", key: "btn-" + role },
                React.createElement(ButtonComponent, { onClick: function () { return _this.setRole(role); }, disabled: isDisabled },
                    React.createElement("div", { className: "flex flex--aligned w100 h-padding__small" },
                        React.createElement(Icon, { icon: roleObj.icon, styleId: IdStyles.IconMedium }),
                        React.createElement("div", { className: "h-padding__small" }),
                        React.createElement(TextLoca, { id: roleObj.loca, className: IdStyles.TextButtonDefault })))));
        };
        _this.setRole = function (role) {
            _this.setState({ selectedRole: role });
        };
        _this.getListDOM = function () {
            var isInProbation = _this.props.isInProbation;
            return isInProbation ? (React.createElement("div", { className: "flex flex--guts h100" },
                React.createElement(TextLoca, { id: IdLoca.floatingText_MemberInProbationary, className: IdStyles.TextNormal }))) : (React.createElement(List, { items: _this.Roles, renderItem: _this.getRoleLayout, className: "flex flex--wrap flex--around" }));
        };
        return _this;
    }
    DialogCoopRoleManagementDOM.prototype.render = function () {
        var coopId = this.props.coopId;
        if (!coopId) {
            return React.createElement(React.Fragment, null);
        }
        var _a = this.props, onClose = _a.onClose, onConfirm = _a.onConfirm, playerId = _a.playerId, playerIdToAssign = _a.playerIdToAssign, isInProbation = _a.isInProbation;
        var selectedRole = this.state.selectedRole;
        var onClick = isInProbation
            ? function () { return onClose(); }
            : function () { return onConfirm(playerId, coopId, playerIdToAssign, selectedRole); };
        var listDOM = this.getListDOM();
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.selectMemberRank_title, onClose: onClose, className: IdStyles.ModalBackgroundLanguageSelection },
            React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around h100" },
                React.createElement("div", { className: "" + IdStyles.LanguageSelectionBackground }, listDOM),
                React.createElement(ButtonPrimary, { onClick: onClick },
                    React.createElement(TextLoca, { id: IdLoca.confirm, className: IdStyles.TextButtonDefault })))));
    };
    return DialogCoopRoleManagementDOM;
}(React.Component));
var mapState = function (state) {
    var onGoingPlayerProfile = selectOngoingPlayerProfileInfo(state);
    var id = onGoingPlayerProfile.id;
    var coop = selectCoopInfo(state);
    return {
        coopId: coop ? coop.id : undefined,
        currentPlayerRole: selectCoopRole(state),
        isInProbation: selectCoopMemberIsInProbation(state, id),
        playerId: selectPlayerInfo(state).playerId,
        playerIdToAssign: id,
        roleToAssign: selectCoopRole(state, id),
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopRoleManagement)); },
    onConfirm: function (playerId, coopId, playerIdToAssign, roleId) {
        if (roleId !== IdCoopRole.Leader) {
            dispatch(actionCoopAssignMemberRole(playerId, coopId, playerIdToAssign, roleId));
            dispatch(actionModalClose(IdModal.CoopRoleManagement));
        }
        else {
            dispatch(actionModalOpen(IdModal.CoopDemoteLeaderConfirm));
        }
    },
}); };
export var DialogCoopRoleManagement = connect(mapState, mapDispatch)(DialogCoopRoleManagementDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogCoopRoleManagement.tsx
// module id = 2567
// module chunks = 3